import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { InitialState } from "./widgetModel";

const initialState: InitialState = {
}

const widgetSlice = createSlice({
    name: 'widget',
    initialState,
    reducers:{
    }
})

export default widgetSlice.reducer
export const {
    
} = widgetSlice.actions